import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Ops.Devices.List";
import Summary from "./Ops.Devices.Summary";

const Devices = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/devices"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/devices/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default Devices;
